import React, { useEffect, useMemo } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { setInitUrl } from 'redux/actions';
import Main from './main';
import Ticket from './ticket';
import Summary from './report/summary';
import Download from './report/download';
import Filter from './filter';
import Ranking from './report/ranking';
import PowerBi from './report/powerbi';
import Relation from './report/relation';
import CustomerVoice from './report/customervoice';
import CatiAdmin from './report/catiadmin';
import User from './user';
import Dealer from './dealer';
import Import from './import';
import Login from './auth/Login';
import Error404 from './error/Error404';
import { ADMIN_TYPES } from 'constants/Systems';
import axios from 'axios';
import { authorizationHeader } from '../util/apiUtil';

const RestrictedRoute = ({ component: Component, ...rest }) => {
  const { authUser } = useSelector(({ auth }) => auth);
  return (
    <Route
      {...rest}
      render={props =>
        authUser ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const Routes = () => {
  const { authUser, initURL } = useSelector(({ auth }) => auth);
  const intl = useIntl();
  const location = useLocation();
  const match = useRouteMatch();
  const dispatch = useDispatch();

  useMemo(() => {
    if (initURL === '') {
      dispatch(setInitUrl(location.pathname));
    }
  }, []);

  useMemo(() => {
    if (authUser) {
      // CALL TO API KEEP USER LOG
      let url = `${process.env.REACT_APP_API_URL}/api/users/audit/log`;
      let translate = location.pathname.replace('/app/', '').replace('/', '.');
      translate = intl.messages[translate]
        ? translate
        : translate.includes('redalert.edit')
        ? 'redalert'
        : 'errors.404.code';

      let result = axios
        .post(
          `${url}`,
          {
            ...location,
            menu: intl.formatMessage({
              id: translate,
            }),
          },
          { headers: authorizationHeader('bearer') },
        )
        .then(response => {});
    }
  });

  if (location.pathname === '' || location.pathname === '/') {
    return <Redirect to={'/app/main'} />;
  } else if (authUser && location.pathname === '/signin') {
    return <Redirect to={initURL === '' || initURL === '/' || initURL === '/signin' ? '/app/main' : initURL} />;
  }

  return (
    <React.Fragment>
      <Switch>
        <RestrictedRoute path={`${match.url}app/main`} component={Main} />
        <RestrictedRoute path={`${match.url}app/summary-report`} component={Summary} />
        <RestrictedRoute path={`${match.url}app/relation`} component={Relation} />
        <RestrictedRoute path={`${match.url}app/powerbi`} component={PowerBi} />
        <RestrictedRoute path={`${match.url}app/ranking`} component={Ranking} />
        <RestrictedRoute path={`${match.url}app/customer-voice`} component={CustomerVoice} />
        <RestrictedRoute path={`${match.url}app/redalert`} component={Ticket} />
        <RestrictedRoute path={`${match.url}app/download`} component={Download} />
        <RestrictedRoute path={`${match.url}app/filter`} component={Filter} />
        <RestrictedRoute path={`${match.url}app/user`} component={User} />
        {authUser && ADMIN_TYPES.includes(authUser.type) && (
          <RestrictedRoute path={`${match.url}app/dealer`} component={Dealer} />
        )}
        {authUser && ADMIN_TYPES.includes(authUser.type) && (
          <RestrictedRoute path={`${match.url}app/import`} component={Import} />
        )}
        {authUser && ADMIN_TYPES.includes(authUser.type) && (
          <RestrictedRoute path={`${match.url}app/catiadmin`} component={CatiAdmin} />
        )}

        <Route exact path="/signin" component={Login} />
        <Route component={Error404} />
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
